<template>
  <flow-block-container
    @remove="$emit('remove')"
    @change-time="$emit('change-time', $event)"
    @lock-time="$emit('lock-time', $event)"
    :show-connection="showConnection"
    :item="value">
    <!--
    <pre class="mini-pre">FROM: {{item.from|shortTime}}<br />TO:   {{item.to|shortTime}}</pre>
    <pre class="mini-pre">{{item}}</pre>
    -->
  </flow-block-container>
</template>

<script>
import FlowBlockContainer from './FlowBlockContainer'

export default {
  props: {
    value: {},
    showConnection: { default: true },
    isEditable: { default: true }
  },
  data: () => ({
    item: {}
  }),
  watch: {
    value: {
      handler(newValue) {
        this.item = newValue;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
  },
  methods: {
    /* onUpdate(data) {
      for (var prop in data) {
        this.item[prop] = data[prop];
      }
      this.$emit("input", this.item);
    }, */
  },
  components: {
    FlowBlockContainer
  }
};
</script>
